import { TELEGRAM_API_URL, OPBNB_SCAN_URL } from '../config/miningConstants';

/**
 * Send Telegram notification to user
 * Lightweight utility - no React dependencies
 */
export const sendTelegramNotification = async (type, data) => {
  const telegramId = localStorage.getItem('smartcore_telegram_id');
  if (!telegramId) return;

  let message = '';
  const timestamp = new Date().toLocaleString('en-US', {
    month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
  });
  
  switch(type) {
    case 'register':
      message = `🎉 *REGISTRATION SUCCESSFUL*\n\n`;
      message += `👤 User ID: \`${data.userId}\`\n`;
      message += `📦 Package: ${data.package}\n`;
      message += `💵 Amount: $${data.amount}\n\n`;
      message += `📅 ${timestamp}\n`;
      message += `🔗 [View TX](${OPBNB_SCAN_URL}/tx/${data.txHash})`;
      break;
      
    case 'upgrade':
      message = `⬆️ *PACKAGE UPGRADED*\n\n`;
      message += `📦 Package: ${data.package}\n`;
      message += `💵 Amount: $${data.amount}\n\n`;
      message += `📅 ${timestamp}\n`;
      message += `🔗 [View TX](${OPBNB_SCAN_URL}/tx/${data.txHash})`;
      break;
      
    case 'retopup':
      message = `🔄 *PACKAGE RETOPPED*\n\n`;
      message += `📦 Package: ${data.package}\n`;
      message += `💵 Amount: $${data.amount}\n\n`;
      message += `📅 ${timestamp}\n`;
      message += `🔗 [View TX](${OPBNB_SCAN_URL}/tx/${data.txHash})`;
      break;
      
    case 'claim':
      message = `✅ *INCOME CLAIMED*\n\n`;
      message += `💰 Amount: $${data.amount}\n\n`;
      message += `📅 ${timestamp}\n`;
      message += `🔗 [View TX](${OPBNB_SCAN_URL}/tx/${data.txHash})`;
      break;
      
    case 'sync':
      message = `🔄 *MINING SYNCED*\n\n`;
      message += `🔋 New Energy: ${data.energy} CORE\n`;
      message += `📊 Sessions: ${data.sessions}\n\n`;
      message += `📅 ${timestamp}\n`;
      message += `🔗 [View TX](${OPBNB_SCAN_URL}/tx/${data.txHash})`;
      break;
      
    case 'mine':
      message = `⛏️ *TOKENS MINED*\n\n`;
      message += `💎 Amount: ${data.amount} CORE\n`;
      message += `📅 Day: ${data.day}\n`;
      message += `⏳ Status: Pending (available after UTC 00:00)\n\n`;
      message += `📅 ${timestamp}\n`;
      message += `🔗 [View TX](${OPBNB_SCAN_URL}/tx/${data.txHash})`;
      break;
      
    case 'claim_mining':
      message = `✅ *MINING CLAIMED*\n\n`;
      message += `💎 Tokens moved to withdrawable balance\n\n`;
      message += `📅 ${timestamp}\n`;
      message += `🔗 [View TX](${OPBNB_SCAN_URL}/tx/${data.txHash})`;
      break;
      
    case 'withdraw':
      message = `💰 *CORE WITHDRAWN*\n\n`;
      message += `💎 Amount: ${data.amount} CORE\n\n`;
      message += `📅 ${timestamp}\n`;
      message += `🔗 [View TX](${OPBNB_SCAN_URL}/tx/${data.txHash})`;
      break;
      
    case 'income_credit':
      message = `💵 *INCOME CREDITED*\n\n`;
      message += `📊 Type: ${data.incomeType}\n`;
      message += `💰 Amount: $${data.amount}\n`;
      message += `👤 From: User #${data.fromUser}\n\n`;
      message += `📅 ${timestamp}`;
      break;
      
    default:
      return;
  }

  try {
    await fetch(TELEGRAM_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'send_message',
        chat_id: telegramId,
        message: message
      })
    });
  } catch (error) {
    console.error('Failed to send Telegram notification:', error);
  }
};
